var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"spinner-bounce",class:_vm.loaderColor},[_c('span',{staticClass:"bounce1 bg-brand-color mr-1"}),_vm._v(" "),_c('span',{staticClass:"bounce2 bg-brand-color mr-1"}),_vm._v(" "),_c('span',{staticClass:"bounce3 bg-brand-color mr-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }